import { useEffect, useState } from "react";
import { CornersOut, CornersIn } from "@phosphor-icons/react";
import { toast } from "sonner";

/**
 * Botón de modo "Kiosko" para tablets en la boca-mina.
 * - Pide fullscreen al navegador
 * - Emite el evento global `kiosk-toggle` para que Layout oculte sidebar / header extra
 * - Persiste la preferencia en localStorage
 * - Sale automáticamente con la tecla Escape (el propio API de fullscreen)
 */
export default function KioskToggle() {
  const [active, setActive] = useState(false);

  // Detectar cambios externos de fullscreen (Escape, F11, gesto del navegador)
  useEffect(() => {
    const sync = () => {
      const on = !!document.fullscreenElement;
      setActive(on);
      window.dispatchEvent(new CustomEvent("kiosk-toggle", { detail: { active: on } }));
      try { window.localStorage?.setItem("kiosk-mode", on ? "1" : "0"); } catch (_e) { /* noop */ }
    };
    document.addEventListener("fullscreenchange", sync);
    return () => document.removeEventListener("fullscreenchange", sync);
  }, []);

  const toggle = async () => {
    try {
      if (!document.fullscreenElement) {
        await document.documentElement.requestFullscreen();
        toast.success("Modo kiosko activo · presiona Esc para salir", { duration: 2500 });
      } else {
        await document.exitFullscreen();
      }
    } catch (_err) {
      toast.error("Este navegador no permite pantalla completa aquí");
    }
  };

  return (
    <button
      onClick={toggle}
      data-testid="kiosk-toggle"
      aria-label={active ? "Salir de modo kiosko" : "Entrar a modo kiosko"}
      title={active ? "Salir de modo kiosko" : "Modo kiosko (pantalla completa · para tablets en mina)"}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md transition-colors text-xs font-semibold touch-manipulation ${
        active
          ? "bg-amber-100 border border-amber-300 text-amber-900 hover:bg-amber-200"
          : "text-slate-600 hover:bg-slate-100 hover:text-blue-900"
      }`}
    >
      {active ? <CornersIn size={16} weight="bold" /> : <CornersOut size={16} weight="bold" />}
      <span className="hidden lg:inline">{active ? "Salir kiosko" : "Kiosko"}</span>
    </button>
  );
}
